module.exports = __webpack_public_path__ + "assets/chart3.2.png?42b33a5922aeb7dffcedffc4010e102d";